module.exports = __webpack_public_path__ + "img/ico-download-hover.b106c097.svg";